import React from "react";
import * as PropTypes from "prop-types";
import './_style.scss';

export default function TopNav({children}) {
    return <div className="top-rail-nav">
        {children}
    </div>;
}

TopNav.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	])
};
